import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import { Fragment } from 'react';
import { bitSet, bitTest } from '@/utils/helpers/bit';
import rotateArray from '../../utils/helpers/array/rotateArray';
import { Checkbox } from '../Checkbox';
import { RadioGroup } from '../RadioGroup';

export type IWeekdaysPickerProps = {
    error?: boolean;
    days?: { id: number; label: string }[];
    disabled?: boolean;
    firstDayOfWeek?: 1 | 7;
    helperText?: string;
    label?: string;
    multiple?: boolean;
    name: string;
    readOnly?: boolean;
    required?: boolean;
    value?: number;
    onChange?: (value: number) => void;
};

export const WeekdaysPicker = ({
    name,
    days = [
        { id: 1, label: 'Mon' },
        { id: 2, label: 'Tue' },
        { id: 3, label: 'Wed' },
        { id: 4, label: 'Thu' },
        { id: 5, label: 'Fri' },
        { id: 6, label: 'Sat' },
        { id: 7, label: 'Sun' }
    ],
    disabled,
    error = false,
    firstDayOfWeek = 1,
    helperText,
    label,
    multiple = false,
    readOnly,
    required,
    value,
    onChange
}: IWeekdaysPickerProps) => {
    const shiftedDays = rotateArray(days, firstDayOfWeek - 1);

    return (
        <>
            {multiple ? (
                <Fragment>
                    {label && <FormLabel required={required}>{label}</FormLabel>}
                    <FormGroup row sx={{ justifyContent: 'center' }} data-testid={`checkbox_group_${name}`}>
                        {days.map((day) => (
                            <FormControlLabel
                                disabled={disabled}
                                sx={{
                                    margin: 1
                                }}
                                key={day.id}
                                label={day.label}
                                value={day.id}
                                name={`${name}.${day.id}`}
                                labelPlacement="bottom"
                                onChange={(_, checked) =>
                                    onChange && onChange(bitSet(value ?? 0, day.id - 1, !checked))
                                }
                                control={
                                    <Checkbox
                                        name={`${name}[]`}
                                        value={bitTest(value ?? 0, day.id - 1)}
                                        readOnly={readOnly}
                                    />
                                }
                            />
                        ))}
                    </FormGroup>
                    {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
                </Fragment>
            ) : (
                <RadioGroup
                    row
                    helperText={helperText}
                    label={label}
                    labelPlacement="bottom"
                    required={required}
                    name={name}
                    disabled={disabled}
                    value={shiftedDays.find((shiftedDay) => bitTest(value ?? 0, shiftedDay.id - 1))?.id ?? 0}
                    options={shiftedDays.map((item) => ({
                        ...item,
                        id: `${item.id}`
                    }))}
                    onChange={(selectedDay) => onChange && onChange(bitSet(0, parseInt(selectedDay) - 1))}
                />
            )}
        </>
    );
};
